import {
  Box,
  Container,
  ImageList,
  ImageListItem,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const useStyle = makeStyles((theme) => ({
  hero: {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.9), rgba(0,0,0,0.5)), url('https://cdn.wccftech.com/wp-content/uploads/2017/12/Best-of-2017-from-Apple-main.png')`,
    height: "100vh",
    position: "relative",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    fontSize: 50,
    [theme.breakpoints.down("md")]: {
      height: 300,
      fontSize: 30,
      justifyContent: "center",
      marginBottom: "20px",
    },
  },
  card: {
    display: "block",
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  abajo: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
    marginLeft: "20px",
  },
  title: {
    color: "black",
    fontWeight: "bold",
  },
  img: {
    width: 150,
    height: 100,
  },
}));

const Home = () => {
  const classes = useStyle();
  const { t, i18n } = useTranslation();

  return (
    <div className="home">
      <Typography variant="h1" color="primary">
        <Box className={classes.hero}>
          <Box className={classes.text}>{t("todo")}</Box>
        </Box>
      </Typography>
      <Container className={classes.card}>
        <Typography className={classes.title} gutterBottom>
          {t("gallery")}
        </Typography>
        <ImageList rowHeight={100} style={{ marginBottom: 20 }} cols={2}>
          <ImageListItem>
            <Link to="/app">
              <img
                src="https://previews.123rf.com/images/enterline/enterline1501/enterline150100029/35292712-la-palabra-apps-escritas-en-tipograf%C3%ADa-de-madera-.jpg"
                alt="Aplicaciones"
                className={classes.img}
              />
            </Link>
          </ImageListItem>
          <ImageListItem>
            <Link to="/games">
              <img
                src="https://previews.123rf.com/images/enterline/enterline1501/enterline150100049/35347451-la-palabra-juegos-escritas-en-tipograf%C3%ADa-de-madera-.jpg"
                alt=""
                className={classes.img}
              />
            </Link>
          </ImageListItem>
          <ImageListItem>
            <Link to="/serie">
              <img
                src="https://previews.123rf.com/images/enterline/enterline1403/enterline140300025/26435384-la-palabra-serie-escrito-en-tipo-de-tipograf%C3%ADa-de-%C3%A9poca.jpg"
                alt=""
                className={classes.img}
              />
            </Link>
          </ImageListItem>
          <ImageListItem>
            <Link to="/movies">
              <img
                src="https://c8.alamy.com/compes/ek8g4w/la-palabra-peliculas-tema-escrito-en-vintage-manchadas-de-tinta-tipografia-de-madera-sobre-un-fondo-de-grano-de-madera-ek8g4w.jpg"
                alt=""
                className={classes.img}
              />
            </Link>
          </ImageListItem>
        </ImageList>
      </Container>
      <Typography className={classes.abajo}>
        <Typography className={classes.title} gutterBottom>
          {t("about-us")}
        </Typography>
        <Typography gutterBottom>
          <p className={classes.about}>{t("tabout")}</p>
        </Typography>
      </Typography>
    </div>
  );
};

export default Home;
